import {useSubscription} from '../../../providers/subscription/useSubscription.ts'
import {SubscriptionErrorBanner} from './SubscriptionErrorBanner.tsx'

export const NoActiveSubscriptionErrorBanner = () => {
  const {activeSubscriptionTier, loading: loadingSubscriptions} = useSubscription()

  if (loadingSubscriptions) return null

  if (activeSubscriptionTier.tier !== 'none') return null

  return <SubscriptionErrorBanner color={'orange'}>You have no active subscription.</SubscriptionErrorBanner>
}
